import { render, staticRenderFns } from "./protectLimit2.vue?vue&type=template&id=0a2ff680&scoped=true"
import script from "./protectLimit2.vue?vue&type=script&lang=js"
export * from "./protectLimit2.vue?vue&type=script&lang=js"
import style0 from "./protectLimit2.vue?vue&type=style&index=0&id=0a2ff680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2ff680",
  null
  
)

export default component.exports